import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesAdminFinanceiro: Routes = [
  {
    path: 'instituicoes_financeiras',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'FIN_INST_FINANCEIRA',
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'FINANCEIRO',
      breadcrumb: {
        label: 'Instituições financeiras',
        icon: 'pi pi-fw pi-building'
      },
      backend_path: '/instituicao_pagamentos'
    },
    loadChildren: () =>
      import(
        '@app/modules/instituicoes-financeiras/instituicao_financeira.module'
      ).then(m => m.InstituicaoFinanceiraModule)
  },
  {
    path: 'formas-pagamento',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'FIN_FORMAS_PAGTO',
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'FINANCEIRO',
      breadcrumb: {
        label: 'Forma pagamento',
        icon: 'mdi mdi-credit-card-outline'
      }
    },
    loadChildren: () =>
      import('@app/modules/forma-pagamento/forma-pagamento.module').then(
        m => m.FormaPagamentoModule
      )
  },
  {
    path: 'condicao-pagamento',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'FIN_COND_PAGTO',
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'FINANCEIRO',
      breadcrumb: {
        label: 'Condição de pagamento',
        icon: 'mdi mdi-cash-multiple'
      }
    },
    loadChildren: () =>
      import('@app/modules/condicao-pagamento/condicao-pagamento.module').then(
        m => m.CondicaoPagamentoModule
      )
  },
  {
    path: 'centro_resultados',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'FIN_CENTRO_RESULTADO',
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'FINANCEIRO',
      breadcrumb: {
        label: 'Centro de resultados',
        icon: 'pi pi-fw pi-money-bill'
      }
    },
    loadChildren: () =>
      import('@app/modules/centro_resultado/centro_resultado.module').then(
        m => m.CentroResultadoModule
      )
  },
  {
    path: 'natureza_financeiras',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'FIN_NAT_FINANCEIRA',
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'FINANCEIRO',
      breadcrumb: {
        label: 'Natureza financeira',
        icon: 'pi pi-fw pi-money-bill'
      }
    },
    loadChildren: () =>
      import(
        '@app/modules/natureza_financeira/natureza_financeira.module'
      ).then(m => m.NaturezaFinanceiraModule)
  },
  {
    path: 'contas-receber',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'FIN_CONTAS_RECEBER',
      menuKey: 'FINANCEIRO',
      breadcrumb: {
        label: 'Contas a receber',
        icon: 'pi pi-fw pi-money-bill'
      }
    },
    loadChildren: () =>
      import('@app/modules/contas-receber/contas-receber.module').then(
        m => m.ContasReceberModule
      )
  },
  {
    path: 'contas-pagar',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'FIN_CONTAS_PAGAR',
      menuKey: 'FINANCEIRO',
      breadcrumb: {
        label: 'Contas a pagar',
        icon: 'pi pi-fw pi-money-bill'
      }
    },
    loadChildren: () =>
      import('@app/modules/contas-pagar/contas-pagar.module').then(
        m => m.ContasPagarModule
      )
  },
  {
    path: 'portadores',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'FIN_PORTADOR',
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'FINANCEIRO',
      breadcrumb: {
        label: 'Portadores',
        icon: 'pi pi-fw pi-money-bill'
      }
    },
    loadChildren: () =>
      import('@app/modules/portador/portador.module').then(
        m => m.PortadorModule
      )
  },
  {
    path: 'movimentacao_financeira',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'FIN_MOV_FINANCEIRA',
      menuKey: 'FINANCEIRO',
      breadcrumb: {
        label: 'Movimentação financeira',
        icon: 'pi pi-fw pi-money-bill'
      }
    },
    loadChildren: () =>
      import(
        '@app/modules/movimentacao_financeira/movimentacao_financeira.module'
      ).then(m => m.MovimentacaoFinanceiraModule)
  },
  // {
  //   path: 'conta_dre',
  //   canActivate: [RenderInterfaceGuard],
  //   data: {
  //     preload: false,
  //     module: 'FIN_CONTA_DRE',
  //     menuKey: 'CONFIGURACOES',
  //     subMenuKey: 'FINANCEIRO',
  //     breadcrumb: {
  //       label: 'Conta DRE',
  //       icon: 'pi pi-fw pi-money-bill'
  //     }
  //   },
  //   loadChildren: () =>
  //     import('@app/modules/conta-dre/conta-dre.module').then(
  //       m => m.ContaDreModule
  //     )
  // },
  {
    path: 'correcao-custo-pedidos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'FIN_CORRECAO_CUSTO_PEDIDO',
      menuKey: 'FINANCEIRO',
      breadcrumb: {
        label: 'Correção de custos do pedido',
        icon: 'pi pi-fw pi-calculator'
      }
    },
    loadChildren: () =>
      import(
        '@app/modules/correcao-custo-pedidos/correcao-custo-pedidos.module'
      ).then(m => m.CorrecaoCustoPedidoModule)
  },
  {
    path: 'estorno',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'FIN_ESTORNO',
      menuKey: 'FINANCEIRO',
      breadcrumb: {
        label: 'Estorno',
        icon: 'mdi mdi-cash-refund'
      }
    },
    loadChildren: () =>
      import('@app/modules/estorno/estorno.module').then(m => m.EstornoModule)
  }
];
